import { render, staticRenderFns } from "./PostHeader.vue?vue&type=template&id=81741276&scoped=true"
import script from "./PostHeader.vue?vue&type=script&lang=js"
export * from "./PostHeader.vue?vue&type=script&lang=js"
import style0 from "./PostHeader.vue?vue&type=style&index=0&id=81741276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81741276",
  null
  
)

export default component.exports